import {
  businessFormedYear,
  businessType,
  filingAllowedForms,
  filingAllowedTaxpreparerForms,
  taxableYears,
  usaStates,
  supportRequestTypes,
  referralServiceTypes,
  cpaLicenseTypes,
  filingStatuses,
  businessFilingStatuses,
  adminActionTypes,
  adminDecisions,
  adminOrdering,
  pageSizes,
  cpaAccountStatuses,
  puchasedAssetsType,
  cryptocurrencyExchanges,
} from "../components/ui/forms/selectOptionData";

const placeholderMap = {
  supportRequestTypes: "Select a support type",
  referralServiceTypes: "Select a service to refer",
  cpaLicenseTypes: "Select license type",
  usaStates: "Select State",
  taxableYears: "Select Year",
  yearFormed: "Select Year",
  businessFormedYear: "Select Year",
  businessType: "Select Business Type",
  filingTaxpayerDocs: "Select Document Type",
  filingTaxpreparerDocs: "Select Document Type",
  cryptocurrencyExchanges: "Select Exchange(s)",
};

export const getSelectPlaceholder = (optionType, customPlaceholder) => {
  if (customPlaceholder) return customPlaceholder;
  return placeholderMap[optionType] || "Select an option";
};

export const getSelectOptions = (optionParam, allowOptions) => {
  const optionsMap = {
    usaStates: () => usaStates(),
    taxableYears: () => taxableYears(),
    filingTaxpayerDocs: () => filingAllowedForms(allowOptions),
    filingTaxpreparerDocs: () => filingAllowedTaxpreparerForms(allowOptions),
    businessType: () => businessType(),
    yearFormed: () => businessFormedYear(),
    businessFormedYear: () => businessFormedYear(),
    supportRequestTypes: () => supportRequestTypes(),
    referralServiceTypes: () => referralServiceTypes(),
    cpaLicenseTypes: () => cpaLicenseTypes(),
    filingStatuses: () => filingStatuses(),
    businessFilingStatuses: () => businessFilingStatuses(),
    adminActionTypes: () => adminActionTypes(),
    adminDecisions: () => adminDecisions(),
    adminOrdering: () => adminOrdering(),
    pageSizes: () => pageSizes(),
    cpaAccountStatuses: () => cpaAccountStatuses(),
    puchasedAssetsType: () => puchasedAssetsType(),
    cryptocurrencyExchanges: () => cryptocurrencyExchanges(),
  };

  return optionsMap[optionParam] ? optionsMap[optionParam]() : [];
};
